import { render, staticRenderFns } from "./bank-authentication.vue?vue&type=template&id=4c8d2246&scoped=true&"
import script from "./bank-authentication.vue?vue&type=script&lang=js&"
export * from "./bank-authentication.vue?vue&type=script&lang=js&"
import style0 from "./bank-authentication.vue?vue&type=style&index=0&id=4c8d2246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d2246",
  null
  
)

export default component.exports